import { render, staticRenderFns } from "./CourseFileUploader.vue?vue&type=template&id=6045acea&scoped=true"
import script from "./CourseFileUploader.vue?vue&type=script&lang=js"
export * from "./CourseFileUploader.vue?vue&type=script&lang=js"
import style0 from "./CourseFileUploader.vue?vue&type=style&index=0&id=6045acea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6045acea",
  null
  
)

export default component.exports